module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/mingyuanyun/wx/activity/index?public_id=39d7a796-d356-3d6b-0e2c-d4d8f0cb818b&org_id=39d85bfe-c42a-5263-88a0-0fa388257b1e"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/icon1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("学习峰会")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/list/0"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/icon3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("典型案例")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/list/1"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/icon4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("明源动态")])])])]), _vm._v(" "), _c('div', {
    staticClass: "qr-code"
  }, [_c('img', {
    staticClass: "two",
    attrs: {
      "src": "https://huiyuanxitong.oss-cn-hangzhou.aliyuncs.com/mingyuanyun/gw/qr-code-my.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("\n            扫码添加“小明”\n            "), _c('br'), _vm._v("添加微信了解更多产品资讯\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e3562cb"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-components/footer/footer.vue
// module id = 290
// module chunks = 1